// extracted by mini-css-extract-plugin
export default {"root":"UserAgreementLink_root__8kVvm"};